<div class="ttmodal">
    <div class="ttmodal__header">
        <span class="ttmodal__title">Add Dealership</span>
        <i class="material-icons ttmodal__close-button" (click)="onNoClick()">close</i>
    </div>
    <div class="ttmodal__body">

        <span class="input-description">Please select the dealer group this dealer belongs to. </span>
        <div class="input-container">
            <span class="label">Dealer Group <span class="red-text">*</span></span>
            <span class="input-icon input-icon--mat">
                <i class="material-icons">location_city</i>
            </span>
            <select [(ngModel)]="selectedDealerGroupId" (change)="dealerGroupSelected($event.target.value)" required class="get-select-text">
                <option value="" disabled selected>Select Dealer Group</option>
                <option *ngFor="let dealergroup of dealergroups" [value]="dealergroup.Id">{{dealergroup.Name}}</option>
            </select>
        </div>
        <div class="input-container">
            <span class="label">Dealership Name <span class="red-text">*</span></span>
            <span class="input-icon input-icon--mat">
                <i class="material-icons">location_city</i>
            </span>
            <input [(ngModel)]="dealershipName" type="text" placeholder="TrackTreads" required>
        </div>
       
        <div class="input-container">
            <span class="label">Phone Number</span>
            <span class="input-icon input-icon--mat">
                <i class="material-icons">phone</i>
            </span>
            <input [(ngModel)]="phone" type="text" placeholder="61400000000" (keypress)="Validate($event)">
        </div>
        <div class="input-container">
            <span class="label">Email <span class="red-text"></span></span>
            <span class="input-icon input-icon--mat">
                <i class="material-icons">mail_outline</i>
            </span>
            <input [(ngModel)]="email" type="text" placeholder="example@email.com">
        </div>
        <div class="input-container">
            <span class="label">Address Line 1</span>
            <span class="input-icon input-icon--mat">
                <i class="material-icons">location_on</i>
            </span>
            <input [(ngModel)]="address1" type="text" placeholder="100 Example Street" >
        </div>

        <div class="input-container">
            <span class="label">Address Line 2</span>
            <span class="input-icon input-icon--mat">
                <i class="material-icons">location_on</i>
            </span>
            <input [(ngModel)]="address2" type="text" placeholder="Example Street" >
        </div>

        <div class="input-container">
            <span class="label">Suburb</span>
            <input [(ngModel)]="suburb" type="text" placeholder="1234">
        </div>
        <div class="input-container">
            <span class="label">Post Code</span>
            <input [(ngModel)]="postCode" type="text" placeholder="1234">
        </div>
        <div class="input-container">
            <span class="label">State</span>
            <input [(ngModel)]="state" type="text" placeholder="Vic">
        </div>

        <span class="input-description">Please select the reports you would like customers within this dealership to be allowed to use. </span>
        <div class="input-container">
            <span class="label">Condition Report Styles <span class="red-text">*</span></span>
            <!-- <angular2-multiselect [data]="dropdownList" [(ngModel)]="selectedItems" [settings]="dropdownSettings" class="get-multi-select"></angular2-multiselect> -->
            <mat-form-field style="width:45%">
                <mat-select [(ngModel)]="selectedItems" multiple>
                    <mat-option *ngFor="let role of dropdownList" [value]="role.ReportId">{{ role.ReportName}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <span class="input-description">Please select the quote reports style you would like customers within this dealership to be allowed to use. </span>
        <div class="input-container">
            <span class="label"> Quote Report Styles <span class="red-text">*</span></span>
            <!-- <angular2-multiselect [data]="availableQuoteReportStyles" [(ngModel)]="selectedQuoteStyles" [settings]="quoteReportSetting" class="get-multi-select"></angular2-multiselect> -->
            <mat-form-field style="width:45%">
                <mat-select [(ngModel)]="selectedQuoteStyles" multiple>
                    <mat-option *ngFor="let role of availableQuoteReportStyles" [value]="role.ReportId">{{ role.ReportName}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="input-container">
            <span class="label">Rope Shovel Report Styles <span class="red-text">*</span></span>
            <!-- <angular2-multiselect [data]="ropedropdownList" [(ngModel)]="ropeselectedItems" [settings]="ropedropdownSettings" class="get-multi-select"></angular2-multiselect> -->
            <mat-form-field style="width:45%">

                <mat-select [(ngModel)]="ropeselectedItems" multiple>
                    <mat-option *ngFor="let role of ropedropdownList" [value]="role.ReportId">{{ role.ReportName}}</mat-option>
                </mat-select>
            </mat-form-field>
        
        </div>

        <!-- <div class="input-container">
            <span class="label">GET Wear Surface Report Styles <span class="red-text">*</span></span>
            <mat-form-field style="width:45%">

                <mat-select [(ngModel)]="wearselectedItems" multiple>
                    <mat-option *ngFor="let role of weardropdownList" [value]="role.ReportId">{{ role.ReportName}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div> -->

        <div class="input-container">
            <span class="label">Undercarriage Rebuild Centre Report Styles <span class="red-text">*</span></span>
            <!-- <angular2-multiselect [data]="wsredropdownList" [(ngModel)]="wsreselectedItems" [settings]="wsredropdownSettings" class="get-multi-select"></angular2-multiselect> -->
            <mat-form-field style="width:45%">
                <mat-select [(ngModel)]="wsreselectedItems" multiple>
                    <mat-option *ngFor="let role of wsredropdownList" [value]="role.ReportId">{{ role.ReportName}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
    <div class="ttmodal__footer">
        <a class="button margin-right-8" (click)="onNoClick()"><span class="button__text">Cancel</span></a>
        <a class="button button--primary" (click)="addNewDealership()" [class.loading]="savingNewDealership"><span class="button__text">Add Dealership</span></a>
    </div>
</div>